import { FilterValues } from "interfaces/filter/filter";
import { filterUtils } from "utils/business/filterUtils";
import { dateUtils } from "utils/common/dateUtils";

const initSavedSettlementFilter = (savedSettlementFilters?: FilterValues): FilterValues => {
    const filters =
        savedSettlementFilters ?
            {
                ...filterUtils.initSavedPerimeterFilters(savedSettlementFilters),
                operationDate: filterUtils.generateOperationDate(savedSettlementFilters?.operationDate)
            }
            : null;

    return filters;
}

const computeFilters = (filters: FilterValues) => {
    return {
        accounts: filters.accounts.map(account => account.id).toString(),
        companies: filters.companies.selectedOptions.map(company => company.id).toString(),
        merchants: filters.merchants.selectedOptions.map(merchant => merchant.id).toString(),
        operationStartDate: dateUtils.formatToISO(filters.operationDate.startDate),
        operationEndDate: dateUtils.formatToISO(filters.operationDate.endDate),
    }
}

export const settlementUtils = {
    initSavedSettlementFilter,
    computeFilters,
}
